export default "__VITE_ASSET__CLUO9yiP__"